module.exports = __webpack_public_path__ + "static/media/your-order.1912dd23.png";